import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './components/app/App';
import './index.css';
import './locale/i18n';
import {
    createBrowserRouter,
    RouterProvider,
} from "react-router-dom";
import Callback, { callbackLoader } from './components/callback/Callback';
import Channels from './components/channel/Channels';
import NewChannel from './components/channel/NewChannel';
import EditChannel from './components/channel/EditChannel';
import Channel from './components/channel/Channel';
import Services from './components/services/Services';
import Logout, { logoutLoader } from './components/callback/Logout';
// import Radio from './components/Radio';

const router = createBrowserRouter([
    {
        path: "/",
        element: <App />,
        children: [
            {
                index: true,
                element: <div>Main Page</div>
            },
            {
                path: '/channel',
                element: <Channels />,
            },
            {
                path: '/channel/new',
                element: <NewChannel />,
            },
            {
                path: '/channel/:id/edit',
                element: <EditChannel />,
            },
            {
                path: '/channel/:id',
                element: <Channel />,
            },
            {
                path: '/services',
                element: <Services />,
            },
            // {
            //     path: '/radio',
            //     element: <Radio />,
            // },
            {
                path: '/logout',
                element: <Logout />,
                loader: logoutLoader,
            },
        ],
    },
    {
        path: "/callback",
        element: <Callback />,
        loader: callbackLoader,
    }
]);

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);
root.render(
    <React.StrictMode>
        <RouterProvider router={router} />
    </React.StrictMode>
);
